import 'angular:locale/data:ar';
import 'angular:locale/data:en';
import 'es-module-shims';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
